import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/about.jpg'


const _hoisted_1 = { class: "about-us-area ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-xxl-5" }
const _hoisted_5 = { class: "about-content" }
const _hoisted_6 = { class: "accordion style-two" }
const _hoisted_7 = { class: "accordion-header" }
const _hoisted_8 = ["aria-expanded", "onClick"]
const _hoisted_9 = { class: "accordion-collapse collapse show" }
const _hoisted_10 = { class: "accordion-body" }
const _hoisted_11 = { class: "ps-0 list-unstyled about-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "section-title mw-860" }, [
        _createElementVNode("span", { class: "top-title" }, "متعة المشاهدة اليومية"),
        _createElementVNode("h2", null, "استمتع بكل ما تحبه من محتوى ترفيهي ورياضي يومياً")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-6 col-xxl-7" }, [
          _createElementVNode("div", { class: "about-img" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "about"
            }),
            _createElementVNode("div", { class: "affordable" }, [
              _createElementVNode("h4", null, "باقات ترفيهية مميزة تبدأ من"),
              _createElementVNode("h2", null, "$ 9.99")
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accordionItems, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["accordion-item", { active: _ctx.activeIndex === index }]),
                  key: index
                }, [
                  _createElementVNode("h2", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "accordion-button pt-0",
                      type: "button",
                      "aria-expanded": _ctx.activeIndex === index ? 'true' : 'false',
                      onClick: ($event: any) => (_ctx.toggleAccordion(index))
                    }, _toDisplayString(item.title), 9, _hoisted_8)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", null, _toDisplayString(item.body), 1),
                      _createElementVNode("ul", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (listItem, i) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: i,
                            class: "d-flex align-items-center"
                          }, [
                            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ti ti-circle-check" }, null, -1)),
                            _createElementVNode("span", null, _toDisplayString(listItem), 1)
                          ]))
                        }), 128))
                      ]),
                      _cache[1] || (_cache[1] = _createElementVNode("a", {
                        href: "https://wa.me/447429916178",
                        target: "_blank",
                        class: "btn"
                      }, [
                        _createElementVNode("span", { class: "border-style" }, "اشترك عبر الواتساب الآن")
                      ], -1))
                    ])
                  ], 512), [
                    [_vShow, _ctx.activeIndex === index]
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}